const locale = {
  "signin.title": "Iniciar Sesión",
  "signin.label.dont.have.account": "No tienes una cuenta?",
  "signin.link.forgot.password": "Olvidaste la contraseña?",
  "signin.button.submit": "Iniciar",
  "signin.label.welcome.first": "Bienvenido a",
  "signin.label.welcome.second": "nuestra compania",
  "signin.label.welcome.third": "Inversapiens ayuda a desarrolladores y reclutadores a encontrarse y asi poder administrar mejor sus proyectos. Unete y comienza a buscar empleados o puestos hoy.",

  "toopbar.menu.profile": "Mi Perfil",
  "toopbar.menu.signout": "Cerrar sesión",

  "sidebar.link.mycourses": "Mis cursos",
  "sidebar.link.students": "Estudiantes",
  "sidebar.link.users": "Usuarios",
  "sidebar.link.courses": "Cursos",
  "sidebar.link.classes": "Clases",
  "sidebar.link.report": "Reportes Financieros",
  "sidebar.link.subscription": "Suscripciones",
  "sidebar.link.configuration": "Configuración",
  "sidebar.menu.admin.title": "Paneles",
  "sidebar.menu.admin.subtitle": "Panel de admin",
  "sidebar.menu.automation.title": "Automatizaciones",
  "sidebar.menu.automation.subtitle": "Panel de automaciones",

  "users.title": "Usuarios",
  "users.label.users": "usuario/s",
  "users.placeholder.search": "Buscar usuarios",
  "users.label.no.users": "No hay usuarios!",
  "users.show.more": "Mostrar más",
  "users.label.projects": "proyecto/s",
  "users.modal.create.title": "Crear Usuario",

  "user.link.users": "Usuarios",
  "user.label.details": "Detalles de usuario",
  "user.tab.info": "Información",
  "user.tab.courses": "Cursos",
  "user.label.no.exist": "Usuario no existe",
  "user.label.search": "Buscar usuario",
  "user.modal.courses.title": "Cursos",
  "user.course.subscription": "Fecha de suscripción: {{date}}",

  "user.role.admin": "Administrador",
  "user.role.professor": "Profesor",
  "user.role.student": "Estudiante",
  "user.role.automation": "Automatización",

  "courses.title": "Cursos",
  "courses.label.courses": "curso/s",
  "courses.placeholder.search": "Buscar cursos",
  "courses.label.no.courses": "No hay cursos!",
  "courses.label.show_more": "Ver más",
  "courses.label.show_less": "Ver menos",
  "courses.modal.create.title": "Crear Curso",
  "courses.empty.title": "Tu espacio de aprendizaje está listo",
  "courses.empty.description": "Cuando tengas cursos asignados, aparecerán aquí con sus clases, recursos y herramientas para que puedas continuar desde un solo lugar.",
  "courses.empty.highlight.classes": "Clases ordenadas",
  "courses.empty.highlight.progress": "Seguimiento simple",
  "courses.empty.highlight.resources": "Recursos exclusivos",
  "courses.empty.help": "Si esperabas ver un curso, contáctanos para revisar tu acceso.",
  
  "course.link.courses": "Cursos",
  "course.label.details": "Detalles del curso",
  "course.tab.info": "Información",
  "course.tab.students": "Estudiantes",
  "course.tab.classes": "Clases",
  "course.modal.assign.title": "Asignar Usuario",
  "course.me.report.error.load.document": "Ocurrió un error al cargar el documento.",
  "course.me.report.loading.pdf": "Cargando PDF...",
  "course.me.report.button.download.report": "Descargar reporte",
  "course.me.report.no.report": "No hay reporte disponible para este curso.",

  "course.alliance.created": "Alianza creada",

  "module.modal.create.title": "Crear Módulo",

  "classes.title": "Clases",
  "classes.label.classes": "clase/s",
  "classes.placeholder.search": "Buscar clases",
  "classes.label.no.classes": "No hay clases!",
  "classes.modal.create.title": "Crear Clase",

  "class.link.classes": "Clases",
  "class.label.details": "Detalles de la clase",
  "class.tab.info": "Información",
  "class.tab.videos": "Videos",
  "class.tab.links": "Links",
  "class.tab.files": "Archivos",
  "class.modal.create.title": "Crear Clase",
  "class.modal.search.title": "Buscar Clase",
  "class.label.assigned": "Ya esta asignada al curso",

  "alert.sure.title": "Está seguro?",
  "alert.sure.delete.course": "Eliminar al usuario del curso {{course}}",
  "alert.sure.delete.user": "Eliminar al usuario {{user}} del curso",
  "alert.sure.delete.class": "Eliminar la clase {{class}} del curso",
  "alert.sure.delete.module": "Eliminar el módulo {{module}} del curso",
  "alert.sure.cancel.button": "Cancelar",
  "alert.sure.confirm.button": "Sí, eliminar",

  "select.placeholder" : "Seleccionar",
  "select.option.all" : "Todos",
  "select.option.active" : "Activos",
  "select.option.inactive" : "Inactivos",

  "label.name": "Name",
  "label.description": "Description",
  "label.email": "Email",
  "label.password": "Contraseña",
  "label.role": "Rol",
  "label.phone": "Teléfono",
  "label.country": "País",
  "label.city": "Ciudad",
  "label.status": "Estado",
  "label.color": "Color",
  "label.professor": "Profesor",
  "label.category": "Caterogía",
  "label.accessible": "Siempre accesible",
  "label.categories": "Categorías",

  "button.select" : "Seleccionar",
  "button.create": "Crear",
  "button.add": "Agregar",
  "button.add.module": "Agregar Módulo",
  "button.add.class": "Agregar Clase",
  "button.update" : "Editar",
  "button.delete" : "Eliminiar",
  "button.save" : "Guardar",
  "button.assign" : "Asignar",
  "button.assigned" : "Asignado",
  "button.block" : "Bloquear",
  "button.unblock" : "Desbloquear",
  "button.categories": "Categorías",

  "button.calendar.send": "Sí, enviar",
}

export default locale;
